<template>
<div>
    <h1 :class="'text-sm pt-2'"> {{$t('form.aucune_garantie.aucune_garantie')}} </h1>
    <div class="shadow border border-gray-200 text-red-600 font-bold p-6 my-4 my-rounded bg-white"> {{$t('form.aucune_garantie.demande_hors_garantie_non_pris_en_charge')}} </div>
</div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'casino-no-warranty',
    extends: FormCardExtension,

    methods: {
        async end() {
            this.nextBlock = this.$formTool.blockData(this.$options.name).next
            this.emitChange()
        },
    },

    mounted() {
        this.end()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/shop/NoWarrantyCard.vue